/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import packageService from './../../services/package';
import packageOrderProductService from './../../services/packageOrderProduct';
import orderProductService from './../../services/orderProduct';
import { mapGetters, mapMutations } from 'vuex';
import Forms from './../../utils/forms/forms';

export default {
  data() {
    return {
       form: new Forms({
        productName: {
          value: '',
          type: 'text',
        },
        quantity: {
          value: '',
          type: 'text',
        },
        quantityUnit: {
          value: '',
          type: 'select',
        },
        grossWeight: {
          value: '',
          type: 'text',
        },
        netWeight: {
          value: '',
          type: 'text',
        },
        stackWeight: {
          value: '',
          type: 'text',
        },
        bestBefore: {
          value: new Date().toISOString().slice(0, 10),
          type: 'date',
        },
        maxTopLoad: {
          value: '',
          type: 'text',
        },
        batchLotNumber: {
          value: '',
          type: 'text',
        },
        temperatureRequirement: {
          value: '',
          type: 'text',
        },
        id: {
          value: '',
          type: 'hidden',
        },
      }),
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      currentOrder: 'currentOrder',
      orderProducts: 'allOrderProducts',
    }),

    loadForms() {
      const qtyUnitOptions = [
        {"id": "PCE", "name": "Piece"},
        {"id": "KGM", "name": "Kilo"},
        {"id": "LTR", "name": "Litre"},
        {"id": "MTR", "name": "Metre"}, 
    ];
      this.form.setOptions('quantityUnit', qtyUnitOptions);
      this.form.assignData(this.$store.state.modal.modalProps);
      //this.form.setFieldValue('packageId', this.$store.state.modal.modalProps.packageId)
    }, 
  },

  created() {
    this.loadForms;
    this.form.disableField('orderProductId')
  },

  watch:{
    
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      modalProps: 'SET_MODAL_PROPS',
    }),

    /*
    * Invoked upon clicking the "save button"
    * 
    */

    update(){
      this.form.loading = true;
      const packageOrderProductUpdate = packageOrderProductService.update(this.form.id, this.form.data())
      .then((data) => {
        orderProductService.all(this.currentOrder.id);
        packageOrderProductService.all(this.currentOrder.id)
        packageService.all(this.currentOrder.id)
        this.$message({
            showClose: true,
            message: this.$t('static.packageOrderProduct.edit.success'),
            customClass: 'success',
        });
        this.closeModal();
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
        let message = this.$t('static.packageOrderProduct.edit.error');
        if (errors.quantityExceedError) {
          message = this.$t('static.packageOrderProduct.edit.quantityExceedError');
        }
        this.$message({
          showClose: true,
          message,
          customClass: 'error',
        });
      });
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/editPackageOrderProduct/editPackageOrderProduct.js